import FacebookIcon from '@honeybook/icons/dist/icons/Facebook';
import TwitterIcon from '@honeybook/icons/dist/icons/TwitterX';
import InstagramIcon from '@honeybook/icons/dist/icons/Instagram';
import PinterestIcon from '@honeybook/icons/dist/icons/Pinterest';
import LinkedinIcon from '@honeybook/icons/dist/icons/Linkedin';
import BehanceIcon from '@honeybook/icons/dist/icons/Behance';
import DribbbleIcon from '@honeybook/icons/dist/icons/Dribbble';
import Tiktok24 from '@honeybook/icons/dist/icons/Tiktok24';
import BlogIcon from '@honeybook/icons/dist/icons/Blog';
import OtherSocialIcon from '@honeybook/icons/dist/icons/Social_other';
import type { Company } from '~/models/company.model';

export function getCompanySocialLinks(company: Company) {
    return [
        {
            key: 'Blog',
            url: company.blog_url,
            icon: BlogIcon,
            placeholder: 'https://www.yourblog.com'
        },
        {
            key: 'Twitter',
            url: company.twitter_url,
            icon: TwitterIcon,
            placeholder: 'https://www.twitter.com/username'
        },

        {
            key: 'Behance',
            url: company.behance_url,
            icon: BehanceIcon,
            placeholder: 'https://www.behance.net/username'
        },

        {
            key: 'Facebook',
            url: company.facebook_url,
            icon: FacebookIcon,
            placeholder: 'https://www.facebook.com/username'
        },
        {
            key: 'Instagram',
            url: company.instagram_url,
            icon: InstagramIcon,
            placeholder: 'https://www.instagram.com/username'
        },
        {
            key: 'Dribbble',
            url: company.dribbble_url,
            icon: DribbbleIcon,
            placeholder: 'https://www.dribbble.com/username'
        },

        {
            key: 'Linkedin',
            url: company.linkedin_url,
            icon: LinkedinIcon,
            placeholder: 'https://www.linkedin.com/in/username'
        },
        {
            key: 'Pinterest',
            url: company.pinterest_url,
            icon: PinterestIcon,
            placeholder: 'https://www.pinterest.com/username'
        },
        {
            key: 'TikTok',
            url: company.tiktok_url,
            icon: Tiktok24,
            placeholder: 'https://www.tiktok.com/@username'
        },

        {
            key: 'Other',
            url: company.other_url,
            icon: OtherSocialIcon,
            placeholder: 'https://www.username.com'
        }
    ] as const;
}
